(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(require('./cart-gift-utils.js'));
  else {
    var element = document.getElementById('CartThresholdGiftsConfig');
    if (element && root.CartGiftRuntime) {
      root.CartGiftRuntime.register(factory(root.CartGiftUtils).createClient(JSON.parse(element.textContent)));
    }
  }
})(typeof window === 'undefined' ? globalThis : window, function (utils) {
  'use strict';
  var marker = '_cart_threshold_gift';

  function isManaged(item) { return (item.properties || {})[marker] === 'true'; }

  function createClient(config) {
    var schedule = utils.createSchedule(config.start, config.end, config.timeZone);
    var gifts = (config.gifts || []).filter(function (gift, index, all) {
      return gift.available && Number.isSafeInteger(gift.variantId) && gift.variantId > 0 &&
        all.findIndex(function (other) { return other.variantId === gift.variantId; }) === index;
    });
    // Retry a failed gift after merchandise changes or a new page load, not in an event loop.
    var failures = {};

    function eligible(cart) {
      return config.enabled === true && Number.isSafeInteger(config.threshold) && config.threshold > 0 &&
        cart.currency === config.currency && schedule.state().active && utils.qualifyingTotal(cart) >= config.threshold;
    }

    function merchandiseKey(cart) {
      return JSON.stringify([cart.currency, utils.qualifyingTotal(cart), cart.items.filter(function (item) {
        return !utils.isGift(item);
      }).map(function (item) { return [item.key, item.quantity, item.final_line_price]; })]);
    }

    async function reconcile(cart, api) {
      var signature = merchandiseKey(cart);
      var wanted = eligible(cart) ? gifts : [];
      var kept = {};
      var updates = {};
      cart.items.filter(isManaged).forEach(function (item) {
        var gift = wanted.find(function (candidate) { return candidate.variantId === item.variant_id; });
        var quantity = gift && !kept[item.variant_id] ? 1 : 0;
        // Theme code cannot set prices. Never intentionally retain a charged gift.
        if (item.quantity === 1 && item.final_line_price !== 0) {
          quantity = 0;
          failures[item.variant_id] = signature;
        }
        if (quantity) kept[item.variant_id] = true;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) cart = await api.update(updates);
      // Quantity reductions can reapply the one-unit gift discount. Inspect the
      // returned prices after normalization before deciding a discount is missing.
      updates = {};
      cart.items.filter(isManaged).forEach(function (item) {
        if (item.final_line_price !== 0) {
          updates[item.key] = 0;
          failures[item.variant_id] = signature;
        }
      });
      if (Object.keys(updates).length) cart = await api.update(updates);
      if (!eligible(cart)) return cart;

      signature = merchandiseKey(cart);
      var missing = gifts.filter(function (gift) {
        return !api.isGiftDismissed(addItem(gift)) && failures[gift.variantId] !== signature && !cart.items.some(function (item) {
          return isManaged(item) && item.variant_id === gift.variantId;
        });
      });
      if (!missing.length) return cart;

      function addItem(gift) {
        return { id: gift.variantId, quantity: 1, properties: { _cart_threshold_gift: 'true' } };
      }
      try {
        await api.add(missing.map(addItem));
        cart = await api.getCart();
      } catch (error) {
        if (error.status !== 422) throw error;
        // Shopify can partially accept an inventory-limited add. Read before retrying
        // individual gifts so one unavailable variant cannot block all the others.
        cart = await api.getCart();
        for (var i = 0; i < missing.length; i++) {
          var gift = missing[i];
          if (!eligible(cart)) break;
          if (api.isGiftDismissed(addItem(gift))) continue;
          if (cart.items.some(function (item) { return isManaged(item) && item.variant_id === gift.variantId; })) continue;
          try { await api.add([addItem(gift)]); }
          catch (individualError) {
            if (individualError.status !== 422) throw individualError;
            failures[gift.variantId] = signature;
          }
          cart = await api.getCart();
        }
      }

      // Adding gifts can change automatic-discount combinations. Re-evaluate the
      // resulting merchandise spend and require the gift's actual line price to be zero.
      updates = {};
      var stillEligible = eligible(cart);
      cart.items.filter(isManaged).forEach(function (item) {
        if (!stillEligible || item.final_line_price !== 0) {
          updates[item.key] = 0;
          failures[item.variant_id] = signature;
        }
      });
      if (Object.keys(updates).length) {
        console.warn('Cart gifts removed: the promotion no longer qualifies or its gift discount is missing.');
        cart = await api.update(updates);
      }
      return cart;
    }

    return {
      reconcile: reconcile,
      scheduleState: function () {
        var state = schedule.state();
        return { key: config.enabled && state.active ? 'active' : 'inactive', future: config.enabled && state.future };
      }
    };
  }
  return { createClient: createClient };
});
